import type { HelpFile } from '../../types/help'
import { UnifiedSearchBarTestIds } from '../../../testids/UnifiedSearchBarTestIds'

export const unifiedSearchBarHelp: HelpFile = {
  docPage: '/docs/reference/unified-search',
  texts: {
    [UnifiedSearchBarTestIds.unifiedSearchBar]: null,
    [UnifiedSearchBarTestIds.inputSearch]:
      'Freitextsuche über die primären Textspalten der Seite — Eingabe bestätigen oder Lupensymbol klicken.',
    [UnifiedSearchBarTestIds.btnFilterTrigger]:
      'Strukturierte Filter öffnen — Einfachauswahl per Radio-Button, Mehrfachauswahl per Checkbox, Datumsfelder für Zeiträume.',
    [UnifiedSearchBarTestIds.btnClearSearch]: null,
  },
}
